import React from "react";

// Visual quote document that matches the requested format. Rendered to PDF.
const QuotePreview = React.forwardRef(({ quote }, ref) => {
  return (
    <div
      ref={ref}
      className="mx-auto w-[794px] bg-white font-display text-slate-800"
      style={{ minHeight: "1123px" }}
    >
      {/* Header */}
      <div className="relative overflow-hidden bg-gradient-to-br from-[#1B3FB8] to-[#2E6BFF] px-12 pb-10 pt-12 text-white">
        <div className="absolute -right-10 -top-10 h-56 w-56 rounded-full bg-white/10" />
        <div className="relative flex items-start justify-between gap-6">
          <div className="max-w-[70%]">
            <h1 className="text-5xl font-extrabold leading-none">{quote.brandTitle}</h1>
            <p className="mt-3 text-sm font-semibold leading-snug text-blue-50">
              {quote.brandSubtitle}
            </p>
          </div>
          <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-2xl bg-white/95 shadow-lg">
            <img src="/logo-uaicard.png" alt="logo" className="h-16 w-auto" crossOrigin="anonymous" />
          </div>
        </div>
        <h2 className="relative mt-6 text-4xl font-bold">{quote.heading}</h2>
      </div>

      {/* Body */}
      <div className="px-12 py-10">
        <p className="text-sm font-bold tracking-[0.15em] text-slate-700">
          {quote.descriptionTitle}
        </p>
        <p className="mt-2 text-[15px] leading-relaxed text-slate-700">
          {quote.descriptionBody}
        </p>

        {/* Table */}
        <div className="mt-8">
          <div className="grid grid-cols-2 border-b-2 border-slate-300 pb-2">
            <span className="text-sm font-bold tracking-[0.15em] text-slate-800">
              {quote.serviceHeader}
            </span>
            <span className="text-sm font-bold tracking-[0.15em] text-slate-800">
              {quote.totalHeader}
            </span>
          </div>
          {quote.items.map((it) => (
            <div key={it.id} className="grid grid-cols-2 gap-4 border-b border-slate-100 py-4">
              <span className="pr-4 text-[15px] leading-snug text-slate-700">{it.service}</span>
              <span className="text-[15px] font-bold text-[#2E6BFF]">{it.total}</span>
            </div>
          ))}
          <div className="grid grid-cols-2 gap-4 py-3">
            <span className="text-right text-sm font-bold tracking-wide text-slate-800">
              {quote.subtotalLabel}
            </span>
            <span className="text-[15px] font-bold text-red-500">{quote.subtotal}</span>
          </div>
          <div className="grid grid-cols-2 gap-4 border-t border-slate-200 py-3">
            <span className="text-right text-sm font-bold tracking-wide text-slate-800">
              {quote.totalLabel}
            </span>
            <span className="text-[15px] font-bold text-red-500">{quote.total}</span>
          </div>
        </div>

        {/* Client & payment */}
        <div className="mt-8 grid grid-cols-2 gap-8">
          <div>
            <p className="text-sm font-bold tracking-[0.15em] text-slate-700">{quote.clientLabel}</p>
            <p className="mt-1 text-lg font-extrabold text-slate-900">{quote.clientName}</p>
            <p className="mt-3 text-xs font-bold italic text-red-500">{quote.deliveryNote}</p>
          </div>
          <div>
            <p className="text-sm font-bold tracking-[0.15em] text-slate-700">{quote.paymentLabel}</p>
            <p className="mt-1 text-base font-bold text-slate-900">{quote.paymentMethod}</p>
            <p className="mt-3 whitespace-pre-line text-sm font-bold text-slate-800">
              {quote.accountInfo}
            </p>
          </div>
        </div>

        <div className="mt-8 space-y-2 border-t border-slate-200 pt-5">
          <p className="text-sm font-semibold text-slate-700">{quote.footerNote}</p>
          <p className="text-sm font-semibold text-slate-700">{quote.footerNote2}</p>
        </div>
      </div>
    </div>
  );
});

export default QuotePreview;
